import React from 'react'
import styled from 'styled-components'
import { wh, fontSize, tabletMinWidth } from '../mixins'

const Button = styled.button`
  ${wh('100%', '56px')};
  min-height: 56px;
  max-width: ${({ customWidth }) => customWidth || '327px'};
  background: ${({ customColor }) => customColor || '#3393EC'};
  color: ${({ customFontColor }) => customFontColor || '#FFFFFF'};
  ${fontSize(14)};
  line-height: 22px;
  font-weight: 600;
  padding: 11px 20px;
  border: none;
  border-radius: 12px;
  position: relative;
  ${({ customMargin }) => customMargin && 'margin:' + customMargin + ';'}
  ${({ customShadow }) => customShadow && 'box-shadow:' + customShadow + ';'}
    z-index: ${({ zIndex }) => zIndex || 'initial'};
  transition: all 0.3s ease-in-out;

  ${({ mobileOnly }) =>
    mobileOnly
      ? `@media screen and (min-width: ${tabletMinWidth}px) {display: none;}`
      : null};

  &:focus {
    outline: none;
  }

  &:hover {
    background: ${({ customHover }) => customHover || '#57A7F1'};
    cursor: pointer;
  }

  &:active {
    background: ${({ customActive }) => customActive || '#0C73D2'};
  }

  &:disabled {
    opacity: 0.5;

    &:hover {
      background: ${({ customColor }) => customColor || '#3393EC'};
      cursor: default;
    }
  }
`

const StickyWrapper = styled.div`
  --bottom-gap: 25px;

  position: ${({ position }) => position || 'fixed'};
  left: auto;
  bottom: ${({ bottomPosition }) => bottomPosition};
  width: ${({ customStickyWidth }) => customStickyWidth || '90%'};
  z-index: ${({ zIndex }) => zIndex || 'initial'};
  display: flex;
  flex-direction: column;
  align-items: center;
  @media screen and (min-width: 600px) {
    position: sticky;
    top: unset;
  }

  &:before {
    content: '';
    display: block;
    width: 100vw;
    height: calc(100% + var(--bottom-gap,1px) + ${({bottomPosition}) => bottomPosition}); // + top + parent bottom
    position: absolute;
    left: calc(-50vw + 50%);
    top: calc(var(--bottom-gap) * (-1));
    background: ${({ customBeforeBg }) =>
      customBeforeBg ||
      `linear-gradient(0deg,#fff 0%,#fff 75%,rgba(255,255,255,0.5) 85%,rgba(255,255,255,0.35) 95%,rgba(255,255,255,0) 100%)`};
    pointer-events: none;
  }
`

const UIButton = ({
  onClick,
  children,
  disabled,
  mobileOnly,
  customFontColor,
  customBeforeBg,
  customColor,
  customHover,
  customActive,
  customMargin,
  customShadow,
  customWidth,
  zIndex,
  position,
  displayStickyBtn = true,
  bottomPosition,
  customStickyWidth,
  stickyProps,
  customId
}) => {
  const btn = (
    <Button
      mobileOnly={mobileOnly}
      onClick={onClick}
      disabled={disabled}
      customFontColor={customFontColor}
      customBeforeBg={customBeforeBg}
      customColor={customColor}
      customHover={customHover}
      customActive={customActive}
      customMargin={customMargin}
      customShadow={customShadow}
      customWidth={customWidth}
      zIndex={zIndex}
      id={customId || 'continue-button'}
    >
      {children}
    </Button>
  )
  return displayStickyBtn && (bottomPosition || stickyProps) ? (
    <StickyWrapper position={position} bottomPosition={bottomPosition} zIndex={zIndex} customBeforeBg={customBeforeBg} customStickyWidth={customStickyWidth} {...stickyProps}>
      {btn}
    </StickyWrapper>
  ) : (
    btn
  )
}

export default UIButton
